import React, {Component} from 'react';

import axios from 'axios';
import auth0Client from '../Auth';
import {ToastContainer, ToastStore} from 'react-toasts';
import {SERVER_URL, LOCAL_URL}  from '../Constants';
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import paginationFactory from 'react-bootstrap-table2-paginator';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
//import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import Modal from 'react-responsive-modal';
import Toggle from "react-toggle-component"
const { SearchBar } = Search;
const reA = /[^a-zA-Z]/g;
const reN = /[^0-9]/g;

const printBarCodeFormatter=(cell,row)=>{

  if (!row.barcode){
    return(
      <button title="print barcode">QR Code</button>
    )
  }
 
}
const columns = [
  
  { dataField: 'name', text: 'name', classes:'text-primary', sort: true, sortFunc:sortAlphaNum, headerAlign: 'center',align: 'left', headerStyle: {width: '200px'}},
  { dataField: 'description', text: 'description',classes:'text-primary', sort: true, headerAlign: 'center',align: 'left', headerStyle: {width: '400px'},},
  { dataField: 'active', text: 'active', classes:'text-primary', sort: true, headerAlign: 'center',align: 'center',headerStyle: {width: '100px'}, formatter:activeStatusFieldFormatter},
  { dataField: 'typeCd', text: 'Type', formatter:getTypeCdStyle, filterable:true, sort: true, headerAlign: 'center',align: 'center'},
  { dataField: 'checkInEnabled', text: 'Checkin Available', classes:'text-primary',sort: true, headerAlign: 'center',align: 'center', formatter:activeStatusFieldFormatter},
  { dataField: 'transferToEnabled', text: 'Transfer Available', classes:'text-primary',sort: true, headerAlign: 'center',align: 'center', formatter:activeStatusFieldFormatter},
  { dataField: 'straightThroughProcessing', text: 'Auto-Add', classes:'text-primary',sort: true, headerAlign: 'center',align: 'center', formatter:activeStatusFieldFormatter},
  

  { dataField: 'barcode', text: 'barcode', classes:'text-primary',sort: true, headerAlign: 'center',align: 'left', headerStyle: {width: '300px'}},
  { dataField: '_id', text: 'QR Code', classes:'text-primary',sort: true, headerAlign: 'center',align: 'center',formatter:printBarCodeFormatter},

];
const columnsAirport = [
  
  { dataField: 'name', text: 'name', classes:'text-primary', sort: true, headerAlign: 'center',align: 'left', headerStyle: {width: '200px'}},
  { dataField: 'description', text: 'description',classes:'text-primary', sort: true, headerAlign: 'center',align: 'left', headerStyle: {width: '400px'},},
  { dataField: 'active', text: 'active', classes:'text-primary', sort: true, headerAlign: 'center',align: 'center',headerStyle: {width: '100px'}, formatter:activeStatusFieldFormatter},
  { dataField: 'typeCd', text: 'Type', formatter:getTypeCdStyle, filterable:true, sort: true, headerAlign: 'center',align: 'center'},
  { dataField: 'checkInEnabled', text: 'Checkin Available', classes:'text-primary',sort: true, headerAlign: 'center',align: 'center', formatter:activeStatusFieldFormatter},
  { dataField: 'transferToEnabled', text: 'Transfer Available', classes:'text-primary',sort: true, headerAlign: 'center',align: 'center', formatter:activeStatusFieldFormatter},
  { dataField: 'straightThroughProcessing', text: 'Auto-Add', classes:'text-primary',sort: true, headerAlign: 'center',align: 'center', formatter:activeStatusFieldFormatter},
  { dataField: 'barcode', text: 'barcode', classes:'text-primary',sort: true, headerAlign: 'center',align: 'left', headerStyle: {width: '300px'}},
  { dataField: 'airportCd', text: 'Airport Code', classes:'text-primary',sort: true, headerAlign: 'center',align: 'center'},
  { dataField: '_id', text: 'QR Code', classes:'text-primary',sort: true, headerAlign: 'center',align: 'center',formatter:printBarCodeFormatter},
];
function sortAlphaNum(a, b, order, dataField, rowA, rowB) {
  //console.log(a + ' vs.' + b);

 
  var aA = a.replace(reA, "");
  var bA = b.replace(reA, "");
  if (aA === bA) {
    var aN = parseInt(a.replace(reN, ""), 10);
    var bN = parseInt(b.replace(reN, ""), 10);
     if (order === 'asc'){
        return aN === bN ? 0 : aN > bN ? 1 : -1;
     }else{
        return aN === bN ? 0 : aN < bN ? 1 : -1;
     }
   
  } else {
    if (order === 'asc'){
      return aA > bA ? 1 : -1;
    }else{
      return aA < bA ? 1 : -1;
    }
   
  }
}


function getTypeCdStyle(cell,row){
  if(cell==='BIN'){
    return (<p className='text-info'>{cell}</p>)
  }else{
    return (<p className='text-primary'>{cell}</p>)
  }
}

function activeStatusFieldFormatter(cell,row){
  if (cell!==undefined){
    return (cell===true) ? 'YES' : 'NO';
  }
}
const paginationOption = {
  custom: true,
  sizePerPage: 50
};


const defaultSorted = [{
  dataField: 'name',
  order: 'asc'
}];



class Locations extends Component {
  constructor(props) {
    super(props);

    this.state = {
      locations: [],
      loading:false,
      showEditor:false,
      activeRow:{},
      editName:'',
      editDescription:'',
      editTypeCd:'',
      editActive:true,
      editCheckInEnabled:false,
      editTransferToEnabled:false,
      editBarcode:'',
      editAirportCd:'',
      editStraightThroughProcessing:false,
      hotSOSRooms:[],
      hotSOSLocationId:'',
      enableWillCLaim:false,

    };
    this.rowEvents = {
      onClick: (e, row, rowIndex, column) => {
        
          console.log('column:' + e.target.tagName);
       if (e.target.tagName==='BUTTON'){
        //let typeCd =  row.typeCd;
        var params = row._id;
        var leftPosition, topPosition;
        let width = 800;
        let height = 600;
        console.log('Row:'+ row)
        //Allow for borders.
        leftPosition = (window.screen.width / 2) - ((width / 2) + 10);
        //Allow for title and status bars.
        topPosition = (window.screen.height / 2) - ((height / 2) + 50);
        //Open the window.
        const url = `${LOCAL_URL}/Locations/PrintLocationLabel/` + params;
        window.open(url, "Window2",
        "status=no,height=" + height + ",width=" + width + ",resizable=yes,left="
        + leftPosition + ",top=" + topPosition + ",screenX=" + leftPosition + ",screenY="
        + topPosition + ",toolbar=no,menubar=no,scrollbars=no,location=no,directories=no");

        return;
       }
        //this.props.history.push('/User/' + row.id);
        //console.log(row._id);
        this.setState(
          {
            activeRow:row, 
            showEditor:true,
            editName:row.name,
            editDescription:row.description,
            editTypeCd:row.typeCd,
            editActive:row.active,
            editCheckInEnabled:row.checkInEnabled,
            editTransferToEnabled:row.transferToEnabled,
            editBarcode:row.barcode,
            editAirportCd:row.airportCd,
            editStraightThroughProcessing:row.straightThroughProcessing,
            hotSOSLocationId:row.hotSOSLocationId,
            venueTypeCd: auth0Client.getDefaultVenue().venueTypeCd,
            enableWillCLaim:row.enableWillCLaim
          });
    
      },
      
    };

  }

    renderToast=()=>{
    return <div>
        
        <ToastContainer position={ToastContainer.POSITION.TOP_RIGHT} lightBackground store={ToastStore}/>
    </div>
}


  // Load the list of locations
  async componentDidMount() {
   
        this.load();
      //  this.loadHotSOSRooms();
    
      
  }

  loadHotSOSRooms=()=>{
    // Only load if hasHotSOSenabled == ture
    let venue=auth0Client.getDefaultVenue();
   
    if (venue && venue.enableHotSOS){
      console.log('Loading Rooms');
      try {
        axios.get(`${SERVER_URL}/SOS/rooms?locationquery=''`,
        { 
          headers: { 
            'Authorization': `Bearer ${auth0Client.getIdToken()}`,
            'venueId': auth0Client.getActiveVenuedId() 
          }
        }
      ).then((res)=>{
        if (res.status===200){
          this.setState({
            hotSOSRooms: res.data.items
        });
     
        }else{
          ToastStore.error('An Error occured. ');
        }
      
      })
    } catch (error) {
      ToastStore.error(error);
    }
    this.setState({
      loading: true
   });
  
    }
  }

  load=()=>{
    
    try {
        axios.post(SERVER_URL + '/locations/query',
        {},
        { 
          headers: { 
            'Authorization': `Bearer ${auth0Client.getIdToken()}`,
            'venueId': auth0Client.getActiveVenuedId() 
          }
        }
      ).then((res)=>{
        if (res.status===200){
          this.setState({
            locations: res.data
        });
       
        }else{
          ToastStore.error('An Error occured. ');
        }
      
      })
    } catch (error) {
      ToastStore.error(error);
    }
    this.setState({
      loading: true
   });
  

    
  }
  handleHotSOSLocationChange=(e)=>{
    const target = e.target;
    const value = target.value;
    this.setState({
      hotSOSLocationId:value
    })
  }

  renderHotSOSRoomsSelection=()=>{
    let venue=auth0Client.getDefaultVenue();
    if (venue && venue.enableHotSOS){
      return (
        <div className='Row'>
          <h6> Default HotSOS&trade; Location:</h6>
          <select
            disabled={this.state.disabled}
            type="text"
            onChange={this.handleHotSOSLocationChange}  //important! 
            name="hotSOSLocationId"
            className="custom-select"
            placeholder=""
            value= {this.state.hotSOSLocationId}
          > 
           <option key='' value=''></option>
                {this.state.hotSOSRooms.map(item => (
                  <option key={item.id} value={item.id} id={item.id}>
                    {item.name }
                  </option>
                ))}
        </select>   
        </div>
      )
    }else{
      return null;
    }
  }
  createNew=()=>{
    let newRow= {
      name:'',
      description:'',
      typeCd:'',
      active:true,
      checkInEnabled:true,
      transferToEnabled:false,
      airportCd:'',
      editBarcode:'',
      hotSOSLocationId:'',
      enableWillCLaim:false
    }
    this.setState({
     
      activeRow:newRow,
      editName:'',
      editDescription:'',
      editTypeCd:'',
      editActive:true,
      editCheckInEnabled:true,
      editTransferToEnabled:false,
      editAirportCd:'',
      editBarcode:'',
      editStraightThroughProcessing:false,
      showEditor:true,
      hotSOSLocationId:'',
      enableWillCLaim:false
    });
  }


  save=()=>{

    try {
      if (this.state.activeRow){
        if (!this.state.editName) {throw new Error('Missing Name')}
        if (!this.state.editTypeCd) {throw new Error('Type is missing')}
        // Set the fields for the row
        let editedRow= this.state.activeRow;
        editedRow.name=this.state.editName;
        editedRow.description=this.state.editDescription;
        editedRow.typeCd=this.state.editTypeCd;
        editedRow.active=this.state.editActive;
        editedRow.checkInEnabled=this.state.editCheckInEnabled;
        editedRow.transferToEnabled=this.state.editTransferToEnabled;
        editedRow.airportCd=this.state.editAirportCd;
        editedRow.barcode = this.state.editBarcode;
        editedRow._id=this.state.activeRow._id;
        editedRow.straightThroughProcessing=this.state.editStraightThroughProcessing;
        editedRow.hotSOSLocationId=this.state.hotSOSLocationId;
        editedRow.enableWillCLaim=this.state.enableWillCLaim;
        //Save the item through API
        axios.post(SERVER_URL + '/locations/updateLocation',
        editedRow,
        { 
          headers: { 
            'Authorization': `Bearer ${auth0Client.getIdToken()}`,
            'venueId': auth0Client.getActiveVenuedId() 
          }
        }
      ).then((res)=>{
        if (res.status===200){
          ToastStore.success('Saved Successfully');
          this.setState({showEditor:false});
          this.load();
        }else{
          ToastStore.error(res.statusMessage);
        }
       
      }).catch((e)=>{
        ToastStore.error(e.response.data);
      })
        
      }
    } catch (error) {
      ToastStore.error(error.message);
    }
   
  }
  renderTypeOptions=()=>{
    if ( auth0Client.getDefaultVenue().venueTypeCd==='A'){

    }else{

    }

  }

 renderScreen =()=>{
  if ( auth0Client.getDefaultVenue().enableWarehouse){
  return(  <div>
              <h6>Add, edit and deactivate locations for your account. Locations are designations for check-in, transfer and BOUNTE Boxes </h6>
                <br/>

                <div className='row'>
                  <div className='col-6'>
                  <button type="button" disabled={auth0Client.lfReadOnly===true} onClick={()=>this.createNew()} className="btn btn-success">New</button>
                  </div>
                  <div className='col-6' style={{textAlign:'right'}}>
                      <button type="button" onClick={()=>this.load()} className="btn btn-primary">Refresh</button>
                  </div>
                </div>

              
                <br/>
                <br/>
                  {this.state.locations === null && <p>Loading Locations...</p>}
                  {this.renderToast()}

                
                

                  <ToolkitProvider 
                    bootstrap4
                      keyField='_id' 
                      data={ this.state.locations } 
                      columns={(this.state.venueTypeCd==='A') ? columnsAirport: columns }
                    
                      search
                      >
                      {
                props => (
                  <div>
                  
                    <SearchBar { ...props.searchProps } />
                    <hr />
                    <BootstrapTable
                      defaultSorted={defaultSorted}
                      striped
                      hover
                      condensed
                      rowEvents={this.rowEvents}
                      
                      { ...props.baseProps }
                      pagination={ paginationFactory(paginationOption) }
                    
                    />
                  </div>
                
                )
              }</ToolkitProvider>

          </div>);



  }else{
    return(  <div> No enabled for this account </div>)
  }
 }
 renderModalEditor=()=>{
  return(
    <Modal  open={this.state.showEditor} onClose={()=>this.setState({showEditor:false})} center>
            <div style={{width:500}}>
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">Location Editor</h5>
                    
                    </div>
                    <div className="modal-body">
                            <p>Items in red are required</p>
                               <div className='row'>
                                    <div className='col'>
                                    <label htmlFor="name" className='text-danger'>Name:</label>
                                                    <input
                                                      disabled={this.state.disabled}
                                                      type="text"
                                                      onChange={(e)=>{this.setState({editName: e.target.value })}}
                                                      name="name"
                                                      className="form-control"
                                                      placeholder="Name"
                                                      value= {this.state.editName}
                                                    />
                                    </div>
                                    <div className='col'>
                                    <label htmlFor="exampleInputEmail1"> Type:</label>
                                         
                                         <select className='custom-select'  value={this.state.editTypeCd} name='typeCd'  onChange={(e)=>{this.setState({editTypeCd: e.target.value })}}>
                                         <option value=""></option>
                                          {(this.state.venueTypeCd==='A') ? <option value="AIRPORT">Airport</option> : null}
                                          {(this.state.venueTypeCd==='A') ?<option value="BSO">Airport BSO</option>: null}
                                          {(this.state.venueTypeCd==='A') ?<option value="TERMINAL">Airport Terminal</option>: null}
                                          {(this.state.venueTypeCd==='A') ?<option value="GATE">Airport Gate</option>: null}
                                           <option value="EXPRESSQR">BOUNTE Express QR&trade;</option>
                                           <option value="BIN">Storage Bin</option>
                                           <option value="WAREHOUSE">Warehouse</option>
                                           <option value="OTHER">Other</option>
                   
                                         </select>
                                    </div>


                                </div>
                                <div className='row'>
                                    <div className='col'>
                                    <label htmlFor="editDescription" className='text-danger'>Description:</label>
                                                    <input
                                                      disabled={this.state.disabled}
                                                      type="text"
                                                      onChange={(e)=>{this.setState({editDescription: e.target.value })}}
                                                      name="editDescription"
                                                      className="form-control"
                                                      placeholder=""
                                                      value= {this.state.editDescription}
                                                    />
                                    </div>
                                </div>
                                <br/>
                                <div className='row'>
                                    <div className='col'>
                                 
                                    <Toggle id='Checkin' labelRight="Check-In Enabled" checked={this.state.editCheckInEnabled} onToggle={value => this.setState({editCheckInEnabled:value})} /> 

                                    </div>
                                    <div className='col'>
                                   
                                    <Toggle id='Transfer' labelRight="Transfer Enabled" checked={this.state.editTransferToEnabled} onToggle={value => this.setState({editTransferToEnabled:value})} /> 

                                    </div>
                                </div>
                                <br/>
                                <div className='row'>
                                    <div className='col'>
                                    <Toggle id='Active' labelRight="Active" checked={this.state.editActive} onToggle={value => this.setState({editActive:value})} /> 

                                    </div>
                                    <div className='col'>
                                  
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col'>
                                    {(this.state.venueTypeCd==='A') ?<div><label htmlFor="editAirportCd" className='text-primary'>Airport Code (optional):</label>
                                                    <input
                                                      disabled={this.state.disabled}
                                                      type="text"
                                                      onChange={(e)=>{this.setState({editAirportCd: e.target.value })}}
                                                      name="editAirportCd"
                                                      className="form-control"
                                                      placeholder=""
                                                      value= {this.state.editAirportCd}
                                                    /></div>: null}

                                    </div>
                                    
                                </div>
                                <div className='row'>
                                <div className='col'>
                                    <label htmlFor="editBarcode" className='text-primary'>Barcode:</label>
                                                    <input
                                                      disabled={this.state.disabled}
                                                      type="text"
                                                      onChange={(e)=>{this.setState({editBarcode: e.target.value })}}
                                                      name="editBarcode"
                                                      className="form-control"
                                                      placeholder=""
                                                      value= {this.state.editBarcode}
                                                    />
                                    </div>
                                </div>
                                <hr/>
                                
                                <div className='row'>
                                    <div className='col'>
                                       <Toggle id='editStraightThroughProcessing' labelRight="Automatically add to BOUNTE. " checked={this.state.editStraightThroughProcessing} onToggle={value => this.setState({editStraightThroughProcessing:value})} /> 
                                         <br/><small>Will not require manually importing from the Dashboard</small>
                                    </div>
                                </div>
                                <br/>
                                <div className='row'>
                                    <div className='col'>
                                    <Toggle id='enableWillCLaim' disabled={this.state.editTypeCd!=='EXPRESSQR'} labelRight="Will Claim Capable" checked={this.state.enableWillCLaim} onToggle={value => this.setState({enableWillCLaim:value})} /> 
                                         <br/><small>Enable the 'Will Claim' checkbox on QR Express.</small>
                                    </div>
                                </div>

                                <br/>
                      {
                      //this.renderHotSOSRoomsSelection()
                      }
                    </div>
                    <div class="modal-footer">
                      <button type="button" onClick={()=>this.setState({showEditor:false})} className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                      <button type="button" onClick={()=>this.save()} disabled={auth0Client.lfReadOnly===true} className="btn btn-primary">Save changes</button>
                   
                    </div>
                  </div>
                </div>
              </div>    
   
  </Modal> 
  )
 }
  
  render() {
    return (

      <div className="container-fluid">
        <h2>Location Manager</h2>
       
       { this.renderScreen()}

    {this.renderModalEditor()}
      




        </div>


    
    )
  }
    
}

export default Locations;